import * as Patient from '../constants/patient.constant'
import { fromPromise } from 'rxjs/observable/fromPromise'
import * as App from '../constants/app.constant'
import { switchMap, map, catchError, tap, finalize } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { from } from 'rxjs/observable/from'
import { loading } from './app.epic'
import {
  getPatientDetailsService,
  getPatientSharedService,
  putPatientSharedService,
} from '../services/patient.service'

const getPatientDetails = action$ =>
  action$.pipe(
    ofType(Patient.GET_PATIENT_DETAILS),
    map((action: any) => action.payload),
    switchMap((payload: any) =>
      fromPromise(
        getPatientDetailsService(payload.patientId, payload.jwtToken)
      ).pipe(
        map(result => ({
          type: Patient.GET_PATIENT_DETAILS_SUCCESS,
          payload: result,
        })),
        catchError(error =>
          from([
            { type: Patient.GET_PATIENT_DETAILS_FAILURE, payload },
            { type: App.SHOW_ERROR, payload: error.message },
          ])
        )
      )
    )
  )

const getPatientShared = action$ =>
  action$.pipe(
    ofType(Patient.GET_PATIENT_SHARED),
    map((action: any) => action.payload),
    switchMap((payload: any) =>
      fromPromise(
        getPatientSharedService(payload.patientId, payload.jwtToken)
      ).pipe(
        map(result => ({
          type: Patient.GET_PATIENT_SHARED_SUCCESS,
          payload: result,
        })),
        catchError(error =>
          from([
            { type: Patient.GET_PATIENT_SHARED_FAILURE, payload },
            { type: App.SHOW_ERROR, payload: error.message },
          ])
        )
      )
    )
  )

const putPatientShared = action$ =>
  action$.pipe(
    ofType(Patient.PUT_PATIENT_SHARED),
    tap(() => loading.show()),
    map((action: any) => action.payload),
    switchMap((payload: any) =>
      fromPromise(
        putPatientSharedService(
          payload.patientId,
          payload.jwtToken,
          payload.enable,
          payload.password
        )
      ).pipe(
        map(result => ({
          type: Patient.PUT_PATIENT_SHARED_SUCCESS,
          payload: result,
        })),
        catchError(error =>
          from([
            { type: Patient.PUT_PATIENT_SHARED_FAILURE, payload },
            { type: App.SHOW_ERROR, payload: error.message },
          ])
        ),
        finalize(() => loading.hide())
      )
    )
  )

const putPatientSharedSuccess = action$ =>
  action$.pipe(
    ofType(Patient.PUT_PATIENT_SHARED_SUCCESS),
    map((action: any) => action.payload),
    switchMap(() =>
      fromPromise(Promise.resolve()).pipe(
        map(() => ({
          type: App.SHOW_SUCCESS,
          payload: '共有許可を変更しました',
        }))
      )
    )
  )

export default [
  getPatientDetails,
  getPatientShared,
  putPatientShared,
  putPatientSharedSuccess,
]



// WEBPACK FOOTER //
// ./src/epics/patient.epic.ts